// inspired by https://github.com/visjs/vis-timeline/issues/1779#issuecomment-2069829371

import { useEffect, useRef } from 'react';
import { Timeline as Vis } from 'vis-timeline';
import { DataSet } from 'vis-data';

const VisTimeline = ({ groups, items, ...opts }) => {
  const containerRef = useRef(null);
  const timelineRef = useRef(null);

  useEffect(() => {
    if (!timelineRef.current) initTimeline();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef]);

  const initTimeline = () => {
    if (!containerRef.current) return;

    timelineRef.current = new Vis(
      containerRef.current,
      new DataSet(items),
      new DataSet(groups),
      opts
    );
  };

  return <div ref={containerRef} />;
};

export default VisTimeline;
